
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import Sparkles from "@/assets/home/Sparkle.svg"; // Using Shape-1 as replacement for Sparkles
import type { Pillar } from "../constants";
import { pillars } from "../constants";
import { cn } from "@/lib/utils";

import type { IconType } from "react-icons";

function IconImage({ Icon, alt, className }: { Icon: IconType; alt: string; className?: string }) {
    return <Icon className={cn("h-10 w-10 text-[#00D1FF]", className)} aria-label={alt} />;
}

export function Hero() {
    return (
        <section className="grid gap-10">
            <div className="flex flex-col gap-6 text-center">
                <span className="mx-auto inline-flex items-center gap-2 rounded-full border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700 dark:text-cyan-200/80">
                    <img src={Sparkles} alt="Sparkles" className="h-4 w-4" /> Consultoria Especializada em IA
                </span>
                <h1 className="text-4xl md:text-6xl font-semibold leading-tight text-slate-900 dark:text-white">
                    <span className="bg-gradient-to-r from-cyan-600 via-blue-500 to-purple-600 dark:from-cyan-300 dark:via-blue-200 dark:to-purple-300 bg-clip-text text-transparent">Boost your Code</span>
                    <br />
                    Scale your Business
                </h1>
                <p className="mx-auto max-w-3xl text-lg text-slate-700 dark:text-slate-200/80">
                    Soluções empresariais em Redes Neurais, Visão Computacional e IA Generativa. Transformamos avanços da IA em
                    resultados reais para o seu negócio.
                </p>
                <div className="flex flex-wrap items-center justify-center gap-4">
                    <a href="#contato">
                        <Button className="bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-950 font-semibold px-6 py-6 text-base shadow-[0_0_40px_rgba(56,189,248,0.25)] hover:shadow-[0_0_50px_rgba(56,189,248,0.35)] cursor-pointer transition-transform hover:scale-105">
                            Iniciar projeto <ArrowRight className="h-4 w-4" />
                        </Button>
                    </a>
                    <a href="#beneficios">
                        <Button variant="outline" className="border-slate-300 dark:border-white/40 bg-slate-100 dark:bg-white/10 text-slate-800 dark:text-white px-6 py-6 text-base hover:bg-slate-200 dark:hover:bg-white/20 cursor-pointer transition-transform hover:scale-105">
                            Conhecer benefícios
                        </Button>
                    </a>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3" aria-label="Pilares de valor">
                {pillars.map((pillar: Pillar) => (
                    <div key={pillar.label} className="flex flex-col items-center gap-3 p-4">
                        <IconImage Icon={pillar.icon} alt={pillar.label} className="h-12 w-12" />
                        <p className="text-sm font-semibold text-slate-900 dark:text-white text-center leading-tight">{pillar.label}</p>
                    </div>
                ))}
                <hr className="col-span-full border-slate-200 dark:border-white/10" />
            </div>
        </section>
    );
}
